// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.columnTree .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {\n  border-color: #aaa;\n}\n.columnTree .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {\n  border-color: #aaa;\n}\n.pending .el-table tr.background {\n  background-color: #FF0000!important;\n  color: #FFF;\n}\n.pending .el-table tr.background:hover td {\n  background-color: #FF0000!important;\n  color: #FFF;\n}\n\n", ""]);
// Exports
module.exports = exports;
